import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import desktopLeftImg from "../../../assets/images/desktop-left-img.svg";
import { useNavigate } from "react-router-dom";

const NeedleEyeDesktopAuthenticate = () => {
  const navigate = useNavigate();

  const handleProceed = () => {
    const whiteboardFlag =
      sessionStorage.getItem("whiteboarding_env") === "true";
    const codingFlag = sessionStorage.getItem("coding_env") === "true";
    if (codingFlag || whiteboardFlag) navigate("/demo-video");
    else navigate("/verification");
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      <Header />

      {/* Main */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
        {/* Left Image */}
        <div className="w-full md:w-1/2 flex justify-center items-center px-4 md:px-6 lg:px-8">
          <img
            src={desktopLeftImg}
            alt="Authenticate NeedleEye Desktop"
            className="object-contain w-full max-w-[520px] h-auto rounded-3xl"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-4 my-[5%]" />

        {/* Right Text */}
        <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
          <div className="max-w-[720px]">
            <h2 className="font-semibold mb-6 leading-snug outer-font-color app-title">
              Authenticate with NeedleEye Desktop
            </h2>

            <p className="mb-4 leading-relaxed outer-font-color app-body">
              To authenticate yourself, enter the 6-Digit Pass Key and your
              Email ID in the{" "}
              <span className="font-semibold">NeedleEye Desktop screen.</span>
            </p>

            <p className="mb-4 outer-font-color app-body">
              The 6-Digit Pass Key was sent to your email along with the
              Assessment Link.
            </p>

            <p className="mb-4 outer-font-color app-body">
              Click on the "Authenticate" button in the{" "}
              <span className="font-semibold">NeedleEye Desktop</span> screen.
            </p>

            <p className="outer-font-color app-body">
              Once your credentials are verified, NeedleEye Desktop will
              continue to run in the background. Click{" "}
              <span className="font-semibold">"Proceed"</span>.
            </p>
          </div>
        </div>
      </div>

      {/* Button */}
      <div className="mt-auto w-full flex justify-end pb-4 pr-4">
        <button
          onClick={handleProceed}
          className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
        >
          Proceed
          <img src={arrowImg} alt="arrow" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
        ©{" "}
        {new Date().getFullYear() > 2026
          ? `2026-${new Date().getFullYear()}`
          : "2026"}
        , Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default NeedleEyeDesktopAuthenticate;
